(function(){
  'use strict';
  // product gallery
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-gal]');
    if(t){
      var main=document.getElementById('galImg');
      if(main){ main.src=t.dataset.gal; main.srcset=''; }
      document.querySelectorAll('[data-gal]').forEach(function(b){b.classList.remove('on');});
      t.classList.add('on');
    }
    var q=e.target.closest('[data-qty]');
    if(q){
      var inp=q.parentNode.querySelector('input');
      var v=Math.max(1,(parseInt(inp.value,10)||1)+parseInt(q.dataset.qty,10));
      inp.value=v;
    }
  });
  // keep the hidden variant id in step with the chosen options
  document.addEventListener('change',function(e){
    var form=e.target.closest('[data-product-form]'); if(!form||e.target.type!=='radio')return;
    var data=document.getElementById('variantData'), idInput=document.getElementById('variantId');
    if(!data||!idInput)return;
    var variants=JSON.parse(data.textContent||'[]');
    var chosen=[].slice.call(form.querySelectorAll('input[type=radio]:checked')).map(function(r){return r.value;});
    var match=variants.filter(function(v){return chosen.every(function(c){return v.options.indexOf(c)>-1;});})[0];
    if(match){ idInput.value=match.id; }
  });
  // engraving field
  var et=document.getElementById('engraveToggle'), eb=document.getElementById('engraveBox'), ei=document.getElementById('engraveText'), ec=document.getElementById('engraveCount');
  if(et&&eb){ et.addEventListener('change',function(){ eb.hidden=!et.checked; if(!et.checked&&ei){ ei.value=''; if(ec) ec.textContent='0'; } });
    if(ei&&ec) ei.addEventListener('input',function(){ ec.textContent=ei.value.length; }); }
  // pincode check (presentational — swap for a real serviceability API)
  var ck=document.getElementById('ckPin');
  if(ck) ck.addEventListener('click',function(){
    var v=(document.getElementById('pin').value||'').trim();
    var m=document.getElementById('pinMsg');
    var ok=/^\d{6}$/.test(v);
    var d=new Date(); d.setDate(d.getDate()+3);
    m.textContent= ok ? '✓ Delivers by '+d.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'})+' · Free insured shipping'
                      : 'Please enter a valid 6-digit pincode';
    m.style.color= ok ? 'var(--ok)' : 'var(--sale)';
  });
})();
